import Marquee from "react-fast-marquee";
import { Crosshair } from "@phosphor-icons/react";

const ITEMS = [
  "EST. 1990",
  "AMERICAN OWNED",
  "VETERAN FRIENDLY",
  "M4 SPECIALISTS",
  "FORT MOHAVE, AZ",
  "FFL TRANSFERS",
];

export default function Ticker() {
  return (
    <div className="bg-oxblood border-y border-blood py-4 overflow-hidden" data-testid="ticker">
      <Marquee speed={55} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase tracking-tight text-2xl md:text-4xl text-bone px-8">
              {t}
            </span>
            <Crosshair size={24} weight="bold" className="text-brass mx-2" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
